var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row home-topo" }, [
    _vm.banners.length
      ? _c(
          "div",
          { staticClass: "col-lg-7 mb-3" },
          [
            _c(
              "b-carousel",
              {
                staticClass: "home-banner",
                attrs: {
                  interval: 5000,
                  controls: _vm.banners.length > 1,
                  indicators: _vm.banners.length > 1
                },
                on: {
                  "sliding-start": _vm.onSlideStart,
                  "sliding-end": _vm.onSlideEnd
                },
                model: {
                  value: _vm.slide,
                  callback: function($$v) {
                    _vm.slide = $$v
                  },
                  expression: "slide"
                }
              },
              _vm._l(_vm.banners, function(banner, index) {
                return _c("b-carousel-slide", {
                  key: index,
                  attrs: { caption: banner.descricao },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "img",
                        fn: function() {
                          return [
                            _c("img", {
                              staticClass: "home-banner-img",
                              attrs: {
                                src: "/storage/" + banner.imagem,
                                alt: banner.descricao
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                })
              }),
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "mb-3 home-lateral",
        class: _vm.banners.length ? "col-lg-5" : "col-12"
      },
      [
        _vm._t("default"),
        _vm._v(" "),
        _c("div", { staticClass: "card home-card home-atalhos" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "list-group list-group-flush" },
            [
              !_vm.pdv
                ? _c(
                    "a",
                    {
                      staticClass: "list-group-item list-group-item-action",
                      attrs: { href: "/distribuidor/revendedoras_indicadas" }
                    },
                    [
                      _c("i", { staticClass: "fas fa-user-plus" }),
                      _vm._v(" Revendedoras pré-cadastradas\n        ")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.downloads, function(download, index) {
                return _c(
                  "a",
                  {
                    key: "d" + index,
                    staticClass: "list-group-item list-group-item-action",
                    attrs: {
                      href: "/storage/" + download.path,
                      target: "_blank"
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-file-download" }),
                    _vm._v(" " + _vm._s(download.descricao) + "\n        ")
                  ]
                )
              }),
              _vm._v(" "),
              _vm.classe == "G" && !_vm.pdv
                ? _c(
                    "a",
                    {
                      staticClass: "list-group-item list-group-item-action",
                      attrs: { href: "/distribuidor/devolucao" }
                    },
                    [
                      _c("i", { staticClass: "fas fa-undo-alt" }),
                      _vm._v(" Devolução\n        ")
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.pdv && !_vm.downloads.length
                ? _c("div", { staticClass: "list-group-item text-muted" }, [
                    _vm._v(
                      "\n          Nenhum material disponível no momento.\n        "
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home-card-header" }, [
      _c("span", [
        _c("i", { staticClass: "fas fa-link" }),
        _vm._v(" Materiais e links úteis")
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47974c65", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47974c65","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/CarouselHome.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-47974c65","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/CarouselHome.vue
// module chunks = 2